import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Switch, Button, Alert } from 'antd';
import { assignCustomerToMarketer } from '../../services/referral/marketerService';
import { NotificationManager } from 'react-notifications';

const ManualAssignModal = ({ visible, onClose, onSuccess, initialCustomerUserId = '', initialSupportCode = '' }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        customerUserId: initialCustomerUserId,
        supportCode: initialSupportCode,
        force: true,
      });
      setError(null);
    }
  }, [visible, initialCustomerUserId, initialSupportCode, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    setError(null);
    try {
      const payload = {
        customerUserId: values.customerUserId?.trim(),
        supportCode: values.supportCode?.trim(),
        force: !!values.force,
      };
      const res = await assignCustomerToMarketer(payload);
      if (res?.status === true || res?.success || res?.message?.toLowerCase().includes('success')) {
        NotificationManager.success(res?.message || 'Customer successfully attributed to marketer');
        if (onSuccess) onSuccess();
        onClose();
      } else {
        setError(res?.message || 'Failed to attribute customer to marketer');
      }
    } catch (err) {
      setError(err?.message || 'An error occurred during customer attribution');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Manually Attribute Customer to Marketer"
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Customer User ID"
          name="customerUserId"
          rules={[{ required: true, message: 'Please enter the Customer User ID' }]}
        >
          <Input placeholder="e.g. CUST_123456" />
        </Form.Item>

        <Form.Item
          label="Marketer Support Code"
          name="supportCode"
          rules={[{ required: true, message: 'Please enter the Marketer Support Code' }]}
        >
          <Input placeholder="e.g. MKT-9921" />
        </Form.Item>

        <Form.Item
          label="Force Re-attribution"
          name="force"
          valuePropName="checked"
          help="If enabled, overrides existing marketer attribution for this customer."
        >
          <Switch checkedChildren="Yes" unCheckedChildren="No" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading} style={{ backgroundColor: '#FF4B01', borderColor: '#FF4B01' }}>
            Submit Attribution
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ManualAssignModal;
